import { LayerType, type Layer, type LayerStyle } from '@pn/core/domain/layer';
import { getLayerId, type WorkspaceItem } from '@pn/core/domain/workspace';
import { clone, startCase } from 'lodash-es';
import { _background } from './_background';
import { crown_mineral_activity } from './crown_mineral_activity';
import { dispositions } from './dispositions';
import { dispositions_historical } from './dispositions_historical';
import { facilities } from './facilities';
import { grids } from './grids';
import { land_postings } from './land_postings';
import { mineral_rights } from './mineral_rights';
import { open_mineral_rights } from './open_mineral_rights';
import { pipelines } from './pipelines';
import { pools } from './pools';
import { units } from './units';
import { wells } from './wells';
import { wells_usa } from './wells_usa';

export const pnWorkspaceItems: Record<WorkspaceItem['id'], WorkspaceItem> = {
  wells,
  wells_usa,
  pipelines,
  facilities,
  mineral_rights,
  open_mineral_rights,
  crown_mineral_activity,
  land_postings,
  units,
  pools,
  dispositions,
  dispositions_historical,
  grids,
  _background,
};

export function generateMapConfig(params: {
  itemId: string;
  type: LayerType;
  style: LayerStyle;
  source: Layer['source'];
  sourceLayer: string;
  renderAsPoints?: boolean;
}): WorkspaceItem['map'] {
  const {
    itemId,
    type,
    style,
    source,
    sourceLayer,
    renderAsPoints = false,
  } = params;

  return {
    layers: [
      {
        id: getLayerId(itemId, itemId, 0),
        name: startCase(itemId),
        type,
        style,
        source,
        sourceLayer,
        renderAsPoints,
      },
    ],
  };
}

export function setOriginalLayers(item: WorkspaceItem): WorkspaceItem {
  return {
    ...item,
    map: {
      ...item.map,
      originalLayers: clone(item.map.layers),
    },
  };
}

export const symbolItemIds = Object.values(pnWorkspaceItems)
  .filter(
    (item) =>
      item.map.layers[0].type === LayerType.Icon ||
      item.map.layers[0].type === LayerType.Text
  )
  .map((item) => item.id);

export const moduleItemIds = ['_background', 'grids'];
